// 한국어 (Korean)
export default {

  // 로고 영역
  logoArea_text_welcome: "환영합니다",
  logoArea_text_myBalance: "잔액:",
  logoArea_btn_register: "회원가입",
  logoArea_btn_login: "로그인",
  logoArea_btn_recharge: "충전",
  logoArea_btn_logout: "로그아웃",

  // 우상단 제목 영역
  headerArea_btn_exitChat_title: "채팅 종료",
  headerArea_btn_history_title: "과거 채팅 열기",
  headerArea_btn_save_title: "채팅 저장",

  // 채팅 영역
  charArea_item_notSupportAudio: "브라우저가 오디오 재생을 지원하지 않습니다",
  charArea_item_historyFileExpire: "기록에서 생성된 파일이 만료되었습니다",

  // 파일 업로드 영역
  uploadArea_btn_uploadFile_defaultText: "파일 업로드",

  // 명령 입력 영역
  inputPanelArea_default_cmdRunFail: "실행 실패",
  inputPanelArea_cmdConfigNotFound: "명령이 존재하지 않습니다",
  inputPanelArea_cmdNotFound: "명령을 찾을 수 없습니다!",
  inputPanelArea_cmdNotNnderstand: "시스템이 의도를 이해하지 못했습니다. 다시 시도해 주세요!",
  inputPanelArea_btn_text_send: "보내기",
  inputPanelArea_btn_text_sending: "전송 중",

  pleaseLoginAfterUse: "서비스를 호출하기 전에 로그인해 주세요",
  registerSuccess: "사용자 등록 성공",
  serviceFail: "인터페이스 요청 실패",
  loginExpired: "로그인이 만료되었습니다. 다시 로그인해 주세요.",
  insufficientBalance: "잔액이 부족합니다. 충전해 주세요.",

  // 확인 대화상자
  confirmed_exitChat_title: "채팅을 종료하시겠습니까?",
  confirmed_exitChat_content: "채팅이 진행 중입니다. 강제로 종료하면 채팅 기록이 손실됩니다. 먼저 저장하는 것을 권장합니다.",
  confirm_overlapChat_title: "과거 채팅 기록 [{{saveName}}]이(가) 존재합니다. 덮어쓰시겠습니까?",
  confirm_overlapChat_content: "채팅이 진행 중입니다. 강제로 종료하면 채팅 기록이 손실됩니다. 먼저 저장하는 것을 권장합니다.",

  // 팝업
  pop_input_saveName_placeholder: "저장 이름을 입력하고 <Enter> 키를 누르세요",

  // 일반 팝업
  modal_title_userLogin: "사용자 로그인",
  modal_title_userRegister: "사용자 등록",
  modal_title_newUser: "환영합니다!",
  modal_title_newRechange: "회원 충전",
  nodal_content_newUser: "Dalipen은 멀티미디어 기술을 발전시키는 데 전념하는 회사입니다. 여기에서 원하는 기능을 선택할 수 있습니다. 시작하는 데 도움이 되도록 100개의 토큰을 준비했습니다.",
  modal_btn_newUser: "시작해 봅시다!",
  modal_btn_okText: "확인",
  modal_btn_cancelText: "취소",
  modal_btn_loginText: "로그인",
  modal_btn_rechange: "충전",
  modal_btn_getEmailCodeText: "이메일 인증 코드 받기",
  modal_btn_registerText: "등록",
  modal_input_rechangeMoney_placeholder: "충전 금액을 입력해 주세요",
  modal_form_email_label: "이메일",
  modal_form_email_errorMsg: "이메일을 입력해 주세요!",
  modal_form_password_label: "비밀번호",
  modal_form_password_errorMsg: "비밀번호를 입력해 주세요!",
  modal_form_code_label: "인증 코드",
  modal_form_code_errorMsg: "인증 코드를 입력해 주세요!",

  // 메시지
  message_save_success: "저장 성공",
  message_warn_isChatting: "채팅이 진행 중입니다. 먼저 저장하는 것을 권장합니다",
  message_error_rechange1: "충전 금액을 입력해 주세요",
  message_error_rechange2: "올바른 금액을 입력해 주세요. 최소값은 1입니다",

  // 결제 결과 페이지
  pay_result_success: "결제 성공",
  pay_result_success_message: "구매해 주셔서 감사합니다!",
  pay_result_fail: "결제 실패",

  // 메뉴 영역
  menu_text: "텍스트",
  menu_text_10001: "SellMeThisPen",
  menu_text_10002: "Tiktok 영상 프롬프트",
  menu_text_10003: "번역",
  menu_text_10004: "이미지 캡셔닝",
  menu_text_10005: "채팅",
  menu_video: "영상",
  menu_video_20001: "템플릿",
  menu_video_20002: "사용자 정의 템플릿",
  menu_video_20003: "디지털 휴먼",
  menu_video_20004: "스타일 전송",
  menu_video_20005: "텍스트 투 영상",
  menu_audio: "오디오",
  menu_audio_30001: "TTS",
  menu_audio_30002: "음성 转 텍스트",
  menu_audio_30003: "보컬 분리",
  menu_image: "이미지",
  menu_image_40001: "텍스트 투 이미지",
  menu_image_40002: "텍스트 투 이미지(flux)",
  menu_image_40003: "텍스트 투 이미지(SD3)",

  // 명령 설정 파일
  command_clean_desc: "현재 대화 상자 지우기",
  command_content_desc: "필드형 명령, 출력 텍스트 콘텐츠 구성용",
  command_mp3Upload_desc: "오디오 MP3 파일 업로드",
  command_mp3Upload_okMsg: "오디오 파일이 성공적으로 업로드되었습니다.\n{{audio:value}}",
  command_mp3Upload_errorMsg: "오디오 파일 업로드 실패, 다시 시도해 주세요",
  command_mp3Upload_ext_buttonText: "오디오 MP3 파일 업로드",
  command_imageUpload_desc: "이미지 파일 업로드",
  command_imageUpload_okMsg: "이미지 파일이 성공적으로 업로드되었습니다.\n{{image:value}}",
  command_imageUpload_errorMsg: "이미지 파일 업로드 실패, 다시 시도해 주세요",
  command_imageUpload_ext_buttonText: "이미지 파일 업로드",
  command_pitch_desc: "필드형 명령, 출력 음높이 구성용 (기본값: 0)",
  command_pitch_okMsg: "지정한 음높이: {{value}}",
  command_pitch_errorMsg: "값 유형 또는 형식이 잘못되었습니다. 숫자여야 합니다",
  command_empty_desc: "",
  command_empty_okMsg: "",
  command_empty_errorMsg: "",
  command_separator_desc: "구분자 음성 (/separator_upload 명령 먼저 실행 필요)",
  command_separator_okMsg: "성공적으로 시작",
  command_separator_errorMsg: "시작 실패, 다시 시도해 주세요",
  command_speechToText_desc: "음성 파일 업로드 및 자동으로 텍스트로 변환",
  command_speechToText_okMsg: "",
  command_speechToText_errorMsg: "",
  command_upload_a_video_ext_buttonText: "영상|이미지 파일 업로드",
  command_upload_a_video_desc: "영상|이미지 업로드",
  command_upload_a_video_okMsg: "",
  command_upload_a_video_errorMsg: "",
  command_upload_a_audio_ext_buttonText: "오디오 파일 업로드",
  command_upload_a_audio_desc: "오디오 업로드",
  command_upload_a_audio_okMsg: "",
  command_upload_a_audio_errorMsg: "",
  command_set_prompt_desc: "프롬프트 설정 (중국어로)",
  command_set_prompt_okMsg: "",
  command_set_prompt_errorMsg: "",
  command_digital_human_desc: "생성",
  command_digital_human_okMsg: "생성 시작",
  command_digital_human_errorMsg: "실패",
  command_txt_2_video_desc: "생성",
  command_txt_2_video_okMsg: "생성 시작",
  command_txt_2_video_errorMsg: "실패",
  command_speaker_desc: "필드형 명령, 음색 선택용 드롭다운 상자",
  command_speaker_okMsg: "지정한 음색:",
  command_choose_style_okMsg: "지정한 스타일:",
  command_language_okMsg: "지정한 언어:",
  command_speed_desc: "필드형 명령, 속도 구성용 (기본값: 1)",
  command_speed_okMsg: "지정한 속도: {{value}}",
  command_speed_errorMsg: "값 유형 또는 형식이 잘못되었습니다. 숫자여야 합니다",
  command_tts_desc: "음성 생성 (/speaker 및 /content 명령 먼저 실행 필요)",
  command_tts_okMsg: "AI 오디오 출력:\n{{audioBlob}}",
  command_tts_errorMsg: "AI 오디오 출력 실패",
  command_volume_desc: "필드형 명령, 출력 볼륨 구성용 (기본값: 1)",
  command_volume_okMsg: "지정한 볼륨: {{value}}",
  command_volume_errorMsg: "값 유형 또는 형식이 잘못되었습니다. 숫자여야 합니다!",

  command_separatorUpload_desc: "MP3 파일 업로드",
  command_separatorUpload_okMsg: "파일 업로드 성공\n{{audio:value}}",
  command_separatorUpload_errorMsg: "리소스 파일 업로드 실패, 다시 시도해 주세요",
  command_separatorUpload_ext_buttonText: "MP3 리소스 파일 업로드",

  // 페이지 링크
  page_link_aboutUs: "회사 소개",
  page_link_privacyPolicy: "개인정보 처리방침",

}